//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Code from './code.vue';
import ForgetPassword from './forget-password.vue';
import { LOGIN_STEP } from '@/utils/constant';
import { gotoHome } from '@/utils/util';

export default {
  name: 'Account',
  components: { Code, ForgetPassword },
  props: {
    storage: {
      type: Boolean,
      default: true,
    },
    redirectUrl: {
      type: String,
      default: '',
    },
    fromUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    // 只有在按下登录后没有拿到手机号/邮箱才会触发这个错误
    const hasVerifyTarget = (rule, value, callback) => {
      if (this.needCode && this.phone === '' && this.email === '') {
        callback(new Error('该账号未绑定手机号或邮箱，请联系管理员绑定后登录'));
      } else {
        callback();
      }
    };
    return {
      formData: {
        account: '',
        password: '',
      },
      // 表单验证对象
      rules: {
        account: [
          {
            required: true,
            message: '请输入员工账号',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入员工密码',
            trigger: 'blur',
          },
          { validator: hasVerifyTarget, trigger: 'blur' },
        ],
      },
      loading: false,
      // 需要验证码
      needCode: false,
      // 当前多因子验证类型：'phone' | 'email'
      mfaType: '',
      // 手机号
      phone: '',
      // 邮箱
      email: '',
      // 六位验证码
      loginCode: '',
      // 临时token
      tmpToken: '',
      // 验证码的时间限制
      timeLimit: 0,
      // 验证码计时器
      timer: null,
      // 忘记密码入口是否可见（仅在登录接口返回密码错误后翻转为 true，一直保留到进入找回视图或页面刷新）
      forgetVisible: false,
      // 是否处于「找回密码」子视图
      forgetMode: false,
    };
  },
  computed: {
    loginValid() {
      return this.formData.account && this.formData.password;
    },
    codeValid() {
      return this.loginCode.length === 6;
    },
  },
  methods: {
    login() {
      if (this.loading) return;
      this.loading = true;
      const url = this.$api.login;
      const type = 'post';

      const data = {
        account: this.formData.account,
        password: this.formData.password,
        login_type: 'admin',
      };
      const cb = (data) => {
        if (data.next_step) {
          this.loading = false;
          this.loginStep(data);
        } else {
          this.loginSuccess(data);
        }
      };
      const fault = (err) => {
        this.loading = false;
        // 识别「密码错误」：axios 拦截器将后端 message 作为 reject 值抛出（见 api/axios.js）
        // 后端 proto `E_INVALID_ACCOUNT_OR_PASSWORD = 4011` 对应的中文文案稳定包含「密码」二字
        // 例如「账号不存在或密码错误」「密码错误」等，此处以 message 文案包含「密码」作为识别依据
        const message = typeof err === 'string' ? err : err?.message || '';
        if (message.indexOf('密码') > -1) {
          this.forgetVisible = true;
        }
      };
      this.$request({ url, cb, type, data, fault, config: this.apiConfig });
    },
    loginWithCode() {
      this.$request({
        url: this.$api.loginWithCode,
        type: 'post',
        data: {
          sms_code: this.loginCode,
          login_type: 'admin',
        },
        tmpToken: this.tmpToken,
        cb: (data) => {
          this.loginSuccess(data);
        },
        config: this.apiConfig,
      });
    },
    loginWithEmailCode() {
      this.$request({
        url: this.$api.loginWithEmail,
        type: 'post',
        data: {
          email_code: this.loginCode,
          login_type: 'admin',
        },
        tmpToken: this.tmpToken,
        cb: (data) => {
          this.loginSuccess(data);
        },
        config: this.apiConfig,
      });
    },
    submitCode() {
      if (this.mfaType === 'email') {
        this.loginWithEmailCode();
      } else {
        this.loginWithCode();
      }
    },
    async loginSuccess(data) {
      console.log('------loginSuccess------', data);
      console.log('------storage------', this.storage);
      this.$message({
        message: '登录成功',
        type: 'success',
      });
      this.$cookies.set('uin', data.uin);
      this.$cookies.set('saas_token', data.token);
      if (this.storage) {
        this.$cookies.set('uin', data.uin);
        this.$cookies.set('saas_token', data.token);
        setTimeout(() => {
          if (this.redirectUrl) {
            window.location.href = `${this.redirectUrl}?token=${encodeURIComponent(data.token)}`;
          } else {
            gotoHome();
          }
        }, 500);
      } else {
        const userInfo = await this.$request({
          url: this.$api.getUserinfo,
          data: {},
          tmpToken: data.token,
        });
        const tenantInfo = await this.$request({
          url: this.$api.getTenantInfo,
          data: {},
          tmpToken: data.token,
        });
        parent.postMessage(
          {
            saas_token: data.token,
            uin: data.uin,
            user_info: userInfo,
            tenant_info: tenantInfo,
          },
          this.fromUrl,
        );
      }
    },
    loginStep(data) {
      if (data.next_step === LOGIN_STEP.phone) {
        this.tmpToken = data.token;
        this.needCode = true;
        this.mfaType = 'phone';

        this.$request({
          url: this.$api.loginGetPhone,
          type: 'post',
          data: {},
          tmpToken: this.tmpToken,
          cb: ({ phone }) => {
            if (phone) {
              this.phone = phone;
              this.getCode();
            } else {
              this.$refs.form.validate(() => {
                this.needCode = false;
              });
            }
          },
          config: this.apiConfig,
        });
      } else if (data.next_step === LOGIN_STEP.email) {
        this.tmpToken = data.token;
        this.needCode = true;
        this.mfaType = 'email';

        this.$request({
          url: this.$api.loginGetEmail,
          type: 'post',
          data: {},
          tmpToken: this.tmpToken,
          cb: ({ email }) => {
            if (email) {
              this.email = email;
              this.getCode();
            } else {
              this.$refs.form.validate(() => {
                this.needCode = false;
              });
            }
          },
          config: this.apiConfig,
        });
      }
    },
    getCode() {
      if (this.timer !== null) return;
      const sendUrl = this.mfaType === 'email' ? this.$api.sendEmailCode : this.$api.sendSmsCode;
      this.$request({
        url: sendUrl,
        type: 'post',
        data: {},
        tmpToken: this.tmpToken,
        config: this.apiConfig,
      });
      this.timeLimit = 30;
      this.timer = setInterval(() => {
        this.timeLimit -= 1;
        if (this.timeLimit === 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    codeChange(code) {
      this.loginCode = code;
    },
    // 进入「忘记密码」子视图
    enterForgetMode() {
      this.forgetMode = true;
    },
    // 从「忘记密码」子视图回到登录视图：保留账号（刚刚走完找回流程的账号）、清空密码、隐藏入口
    onBackToLogin() {
      this.forgetMode = false;
      this.forgetVisible = false;
      this.formData.password = '';
    },
    // 跳转到注册页
    goToRegister() {
      this.$router.push({ name: 'register' });
    },
  },
};
